import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import LandingPage from "./components/layout/LandingPage";

import ScrollToTop from "./components/layout/ScrollToTop"; 
import Portfolio from './components/pages/portfolio/Portfolio';
import ProjectDetails from './components/layout/ProjectDetails';
import Gallery from "./components/pages/gallery/Gallery";
// import Chatbot from "react-chatbot-kit";
// import NotFound from "./components/pages/NotFound"; 


// Lazy Loading Pages
const Home = lazy(() => import("./components/pages/home/Home"));
const About = lazy(() => import("./components/pages/about/About"));
//const Portfolio = lazy(() => import("./components/pages/portfolio/Portfolio"));
const Blogs = lazy(() => import("./components/pages/blog/Blogs"));
const Contact = lazy(() => import("./components/pages/contact/Contact"));
const FAQ = lazy(() => import("./components/pages/faq/FAQ"));
const Services = lazy(() => import("./components/pages/services/Services"));
const WhyChooseUs = lazy(() => import("./components/pages/whychooseus/WhyChooseUs"));
const Team = lazy(() => import("./components/pages/team/Team"));
const Careers = lazy(() => import("./components/pages/careers/Careers"));
const CareersForm = lazy(() => import("./components/pages/careers/CareersForm"));
const MissionValues = lazy(() => import("./components/pages/mission-values/MissionValues"));
const OurPeopleCulture = lazy(() => import("./components/pages/our-people-culture/OurPeopleCulture"));
const TeamViewerTest = lazy(() => import("./components/pages/team-viewer-test/TeamViewerTest"));
const OffshoreOffices = lazy(() => import("./components/pages/offshoreoffices/OffshoreOffices"));
const MobileAppDevelopment = lazy(() => import("./components/pages/mobile-app-development/MobileAppDevelopment"));
const ThirdPartyAPIIntegration = lazy(() => import("./components/pages/third-party-api-integration/ThirdPartyAPIIntegration"));
const UIUXDesign = lazy(() => import("./components/pages/ui-ux/UIUXDesign"));
const WebDevelopment = lazy(() => import("./components/pages/web-development/WebDevelopment"));
const BusinessIntelligenceServices = lazy(() => import("./components/pages/business-intelligence/BusinessIntelligence"));
const gallery = lazy(() => import("./components/pages/gallery/Gallery"));
const NotFound = lazy(() => import("./components/pages/notfound/NotFound"));

const App = () => {
  return (
    <Router>
      <ScrollToTop /> 
      <Header />
     
       
  
      <>
        <Suspense fallback={<div className="loading-screen">Loading...</div>}>
          <Routes>
          <Route path="/" element={<LandingPage />} />
            {/* <Route path="/" element={<Home />} /> */}
            <Route path="/About" element={<About />} />
            <Route path="/success-stories" element={<Portfolio />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faqs" element={<FAQ />} />
            <Route path="/services" element={<Services />} />
            <Route path="/why-choose-us" element={<WhyChooseUs />} />
            <Route path="/team" element={<Team />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/careersform" element={<CareersForm />} />
            <Route path="/about-us" element={<MissionValues />} />
            <Route path="/our-people-culture" element={<OurPeopleCulture />} />
            <Route path="/machine-test" element={<TeamViewerTest />} />
            <Route path="/offshoreoffices" element={<OffshoreOffices />} />
            <Route path="/mobile-app-development" element={<MobileAppDevelopment />} />
            <Route path="/third-party-api-integration" element={<ThirdPartyAPIIntegration />} />
            <Route path="/ui-ux" element={<UIUXDesign />} />
            <Route path="/web-development" element={<WebDevelopment />} />
            <Route path="/business-intelligence" element={<BusinessIntelligenceServices />} />

            <Route path="/gallery" element={<Gallery />} />
            <Route path="/project-details/:id" element={<ProjectDetails />} />
            <Route path="*" element={<NotFound />} /> 
          </Routes>
        </Suspense>
      </>
      <Footer />
    </Router>
  );
};

export default App;
